import {
  merge, propEq, find, clone
} from 'ramda';
import {
  LOAD_SUCCESS,
  LOAD_OPTIONS_SUCCESS,
  LOAD_REQUEST,
  LOAD_FAIL,
  UPDATE_FAIL,
  UPDATE_REQUEST,
  UPDATE_SUCCESS
} from 'src/store/actions/tvActions';

const initialState = {
  list: [],
  options: [],
  fetching: false,
  errors: []
};

const updateConfiguration = (result, prop, list) => {
  const tvList = clone(list);
  const updatedResult = find(propEq('DeviceId', parseInt(result[prop], 10)), tvList);
  if (updatedResult !== undefined) {
    updatedResult.Configuration = result.Configuration;
    return tvList;
  }
  return list;
};

const TvReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case LOAD_SUCCESS:
      return merge(state, {
        list: action.tv,
        fetching: false,
        errors: []
      });
    case LOAD_OPTIONS_SUCCESS:
      return merge(state, {
        options: action.options,
        fetching: false,
        errors: []
      });
    case UPDATE_REQUEST:
      return merge(state, { fetching: true });
    case UPDATE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case UPDATE_SUCCESS:
      return merge(state, {
        list: updateConfiguration(action.result, 'DeviceId', state.list),
        fetching: false,
        errors: []
      });
    default:
      return state;
  }
};

export default TvReducer;
